import { useContext, useEffect, useState } from 'react';
import { throttleTime } from 'rxjs/operators';
import { EnvContext } from '../../controllers/workbench/context.js';

function useObservableState(key, defaultValue, throttle = 10, scheduler) {
    const context = useContext(EnvContext);
    useEffect(() => {
        if (!context.store.has(key)) {
            context.store.register(key, defaultValue);
        }
    }, [context.store, key, defaultValue]);
    const [state, setState] = useState(() => { var _a; return (_a = context.store.getValue(key)) !== null && _a !== void 0 ? _a : defaultValue; });
    useEffect(() => {
        const observable = context.store.get(key);
        const subscription = observable.pipe(throttleTime(throttle, scheduler, {
            leading: true,
            // 可能会忽略短时间触发的最后一次更新，导致组件渲染出现问题
            trailing: true,
        })).subscribe((data) => {
            setState(data);
        });
        return () => {
            subscription.unsubscribe();
        };
    }, [key, context.store, throttle, scheduler]);
    return state;
}

export { useObservableState };
//# sourceMappingURL=use-observable-state.js.map
